// Mortgage broking businesses and property clients share one lead table. They
// are told apart by the stage they sit on: an MB business is on a stage whose
// name starts "MB -". The dashboard funnel already groups stages this way
// (StageHistoryService.GroupOf in the API), so this keeps one convention
// rather than introducing a second.

export const MB_STAGE_PREFIX = "MB -";

export function isMbStageName(name: string | null | undefined): boolean {
    const n = (name ?? "").trim().toLowerCase();
    return n.startsWith("mb -") || n.startsWith("mb-");
}

export type LeadTypeFilter = "all" | "property" | "mb";

export const LEAD_TYPE_OPTIONS = [
    { value: "property", label: "Property" },
    { value: "mb", label: "MB Business" },
    { value: "all", label: "All" },
];

// Rows from the lead lists carry the stage name, not its id.
export function filterLeadsByType(leads: any[], type: LeadTypeFilter): any[] {
    if (type === "all") return leads;
    const wantMb = type === "mb";
    return leads.filter((lead: any) => isMbStageName(lead?.stage) === wantMb);
}

// Stage dropdowns: MB Builder offers only MB stages, the property screens
// offer only the rest.
export function mbStages(options: any[]): any[] {
    return options.filter((o: any) => isMbStageName(o?.label));
}

export function propertyStages(options: any[]): any[] {
    return options.filter((o: any) => !isMbStageName(o?.label));
}
